/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：201
 */

module.exports = {
  hide: "style_hide__21aDR",
  "coco-widget-wrapper": "style_coco-widget-wrapper__2w9cj",
  "coco-child-widget": "style_coco-child-widget__1E8Er",
  "coco-child-widget-selected": "style_coco-child-widget-selected__1ptOP",
  "coco-child-widget-full": "style_coco-child-widget-full__3ERpt",
  switchWidget: "style_switchWidget__3fYrB",
  default: "style_default__2UV70",
  handle: "style_handle__1H0JK",
  leftAnimation: "style_leftAnimation__3AHh8",
  primary: "style_primary__3Frnd",
  templateWrapper: "style_templateWrapper__1nHYi",
  imageAnimationFirstHalf: "style_imageAnimationFirstHalf__2Oh-K",
  "image-animation-first-half": "style_image-animation-first-half__1oOJB",
  imageAnimationSecondHalf: "style_imageAnimationSecondHalf__23SxR",
  "image-animation-second-half": "style_image-animation-second-half__201nn"
}
